<template>
  <div id="main">
    <router-view />
    <vue-cookie-accept-decline
      v-if="config.featureCookieBar"
      ref="cookie"
      element-id="cookie"
      :disable-decline="true"
      transition-name="fade"
    >
      <template #message>
        <div class="cookie-bar__top">
          <img src="@/assets/images/cookie.png" />
          <div class="cookie-bar__text">
            <p class="cookie-bar__description">
              {{ $t("common.cookies.text") }}
            </p>
          </div>
        </div>
        <div class="cookie-bar__bottom">
          <a
            :href="cookiesDetailsUrl"
            target="_blank"
            class="cookie-bar__learn-more-link"
          >
            {{ $t("common.cookies.detailBtn") }}
          </a>
          <button-component class="btn-cookie" md @click="acceptCookie">
            {{ $t("common.cookies.acceptBtn") }}
          </button-component>
        </div>
      </template>
    </vue-cookie-accept-decline>
  </div>
</template>

<script lang="ts" setup>
import config from "./config"
import dayjs from "dayjs"
import { useReCaptcha } from "vue-recaptcha-v3"
import VueCookieAcceptDecline from "vue-cookie-accept-decline"
import { onMounted, ref, useTemplateRef, watch } from "vue"
import { useRoute } from "vue-router"
import { useI18n } from "vue-i18n"
import { useDictionaryStore } from "./store/dictionary"
import ButtonComponent from "./components/ui/ButtonComponent.vue"

const route = useRoute()
const { fetchDynamicConfig } = useDictionaryStore()
const { locale } = useI18n()

const cookiesDetailsUrl = ref(config.links.cookie)

const cookieRef = useTemplateRef<typeof VueCookieAcceptDecline>("cookie")

const langFromUrl = route.query.lang
const langFromLocaleStorage = localStorage.getItem("guest-charging_locale")
const langFromConfig = config.defaultLanguage
const languageToSet =
  (langFromUrl as string) || langFromLocaleStorage || langFromConfig

if (config.languages.includes(languageToSet)) {
  locale.value = languageToSet
  dayjs.locale(languageToSet)
}

watch(locale, (newLanguage: string) => {
  localStorage.setItem("guest-charging_locale", newLanguage)

  dayjs.locale(newLanguage)
})

fetchDynamicConfig()

const recaptcha = async () => {
  const recaptcha = useReCaptcha()

  if (recaptcha) {
    await recaptcha.recaptchaLoaded()
    recaptcha.instance.value?.hideBadge()
  }
}

const acceptCookie = () => {
  cookieRef.value?.accept()
}

onMounted(() => {
  recaptcha()
})
</script>
